export default __webpack_public_path__ + "static/media/aboutImage.70c28c54.jpg";